import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton } from 'react-share';
import React from 'react';

import ClipboardIcon from './icons/ClipboardIcon';
import CopyToClipboardButton from './buttons/CopyToClipboardButton';
import styles from './ShareContent.module.scss';
import { useEventSettings } from '../../../data/hooks/events/useEventSettings';

const ShareContent = (props) => {
    const { url, message, style = {} } = props,
        iconProps = {
            size: 56,
            round: true,
        },
        { twitter_disabled } = useEventSettings()

    return (
        <div className={styles.ShareContent} style={style}>
            <LinkedinShareButton url={url} summary={message} source="https://app.networkapp.com/">
                <LinkedinIcon {...iconProps} />
            </LinkedinShareButton>
            {twitter_disabled ? (
                <TwitterShareButton url={url} title={message}>
                    <TwitterIcon {...iconProps} />
                </TwitterShareButton>
            ) : null}
            <FacebookShareButton url={url} quote={message}>
                <FacebookIcon {...iconProps} />
            </FacebookShareButton>
            <CopyToClipboardButton content={url}>
                <ClipboardIcon {...iconProps} />
            </CopyToClipboardButton>
            <EmailShareButton url={url} subject={message}>
                <EmailIcon {...iconProps} />
            </EmailShareButton>
        </div>
    );
};

export default ShareContent;
